"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScreenSharingStream = getScreenSharingStream;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _StudioLogger = require("@studio/logger/StudioLogger");
var _DisplaySurfaceTypes = require("@studio/constants/DisplaySurfaceTypes");
var loggerName = 'ScreenShare-Helper';
var logger = new _StudioLogger.StudioLogger(loggerName);
/**
 * This method will log the shared display surface and returns media stream to handle screen sharing.
 * @returns the media stream, the type of screen share and if audio is included in the stream.
 */
function getScreenSharingStream() {
  return _getScreenSharingStream.apply(this, arguments);
}
function _getScreenSharingStream() {
  _getScreenSharingStream = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var stream, hasAudio, settings, shareType, _t;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 1;
          return navigator.mediaDevices.getDisplayMedia({
            video: true,
            audio: true
          });
        case 1:
          stream = _context.sent;
          hasAudio = stream.getAudioTracks().length > 0;
          settings = stream.getVideoTracks()[0].getSettings();
          logger.info('Screen share stream settings.', {
            streamSettings: settings
          });

          // Edge case: The stream exists but is blank, screen share failed for an unknown reason
          if (!(!settings.width || !settings.height || settings.width === 0 || settings.height === 0)) {
            _context.next = 2;
            break;
          }
          stopTracks(stream);
          throw new Error('Unable to start a screenshare.');
        case 2:
          shareType = _DisplaySurfaceTypes.DISPLAY_SURFACE_TYPES[settings.displaySurface] || settings.displaySurface;
          console.log("User chose to share: ".concat(shareType).concat(hasAudio ? ' with audio.' : ' without audio.'));
          logger.info("User shared ".concat(shareType).concat(hasAudio ? ' with audio.' : ' without audio.'), {
            shareType: shareType,
            hasAudio: hasAudio
          });
          return _context.abrupt("return", {
            stream: stream,
            hasAudio: hasAudio,
            shareType: shareType
          });
        case 3:
          _context.prev = 3;
          _t = _context["catch"](0);
          logger.error("Error while creating screen sharing stream.", {
            error: _t
          });
          throw _t;
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 3]]);
  }));
  return _getScreenSharingStream.apply(this, arguments);
}
var stopTracks = function stopTracks(stream) {
  stream.getTracks().forEach(function (track) {
    return track.stop();
  });
};